import React, { useEffect, useRef, useState } from 'react'
import './create-from-template.styles.scss';
import { useSelector } from 'react-redux';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import { ModalAlert, ModalConfirm } from '@/components/modal/modal.component';
import UpgradeRequiredModal from '@/components/SHARED/upgrade-required-modal/upgrade-required-modal.component';
import { membershipRestrictions, testMemberRestrictions } from '@/utils/membershipRestrictions';
import { UseCloudFunction } from '@/utils/firebase.utils';
import { Link, Route, Routes, useNavigate } from 'react-router-dom';
import BackButton from '@/components/SHARED/back-button/back-button.component';
import FullPageLoader from '@/components/loader/full-page-loader.component';
import TemplateGamePreview from './template-game-preview.component';
import { getQueryFromFirestore, getQueryFromRtDb } from '@/utils/getDataFromDbSimplified';


const CreateFromTemplate = ({
  managingList,
}) => {

  const userProfile = useSelector(state => state.userData.userProfile);
  const membership = useSelector(state => state.userData.membership);
  const screenSize = useSelector(state => state.contentData.screenSize);
  const [gamesToDisplay, setGamesToDisplay] = useState(null);
  const [alertMessage, setAlertMessage] = useState(null);
  const [confirmMessage, setConfirmMessage] = useState(null);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const [allowUpgradeClose, setAllowUpgradeClose] = useState(false);
  const [loading, setLoading] = useState(false);
  const [allowUpgradeModal, setAllowUpgradeModal] = useState(true);
  const approveRef = useRef();
  const gameRef = useRef();
  const navigate = useNavigate();

  useEffect(() => {
    if (!userProfile || !membership) return;
    getFreeTemplateGames();
    // getMyTemplateGames();
  }, [userProfile, membership]);

  useEffect(() => {
    console.log(managingList);
    checkMembership();
  }, [managingList]);

  function checkMembership() {
    if (!managingList || Object.values(managingList).length === 0) {
      return;
    }
    const res = testMemberRestrictions({ 'gameCount': Object.values(managingList).length, 'membership': membership });
    if (res.disabled && res.disabledReason.includes('games') && allowUpgradeModal) {
      const planRest = membershipRestrictions[membership.membership];
      const message = `While using the ${planRest.title}, you are only able to have ${planRest.gameCount} active Games.`;
      setAllowUpgradeClose(false);
      // setShowUpgradeModal(message);
      return;
    }
  }

  async function getFreeTemplateGames() {
    getQueryFromFirestore({
      'path': 'contentLibrary',
      'queryArray': [
        {
          'field': 'type',
          'operator': '==',
          'value': 'templateGame'
        },
        {
          'field': 'status',
          'operator': '==',
          'value': 'active'
        }
      ],
      'once': true,
      'callback': callback
    })
    function callback(data) {
      console.log(data);
      if (
        (data.openDate && data.openDate > new Date().getTime()) || 
        (data.closeDate && data.closeDate < new Date().getTime())
      ) {
        return;
      }  
      gameRef.current = {
        ...gameRef.current,
        ...data
      }
      setGamesToDisplay(gameRef.current);
    }
  }

  async function getMyTemplateGames() {
    getQueryFromRtDb({
      'path': `myContent/${userProfile.appId}`,
      'query': {
        'key': 'type',
        'value': 'game'
      },
      'once': true,
      'callback': (data) => {
        console.log(data);
        gameRef.current = {
          ...gameRef.current,
          ...data
        }
        setGamesToDisplay(gameRef.current);
      }
    })
  }

  function createGame(gameId) {
    if (!gameId) return;
    const gameElement = gameRef.current[gameId];
    console.log(gameElement);
    if (!gameElement) {
      setAlertMessage('This template game is not available at the moment. Please try again later.');
      return;
    }
    if (membership?.membership < gameElement.access) {
      const message = 'Because this is a game template that requires a higher plan, you must upgrade before using it.';
      setAllowUpgradeClose(true);
      setShowUpgradeModal(message);
      return;
    }
    console.log(managingList)
    if (Object.values(managingList).length >= membershipRestrictions[membership?.membership].gameCount) {
      const message = `You have reached the maximum number of games allowed with your current plan. Please upgrade to create more games, or archive existing games to free up space.`;
      setAllowUpgradeClose(true);
      setShowUpgradeModal(message);
      return;
    }
    setConfirmMessage(`Are you sure you want to create a new game using the template called <b>"${gameElement.gameData.gameName}"</b>? This will create a new game in your account.`);
    approveRef.current = () => {
      approveRef.current = null;
      continueCreateGame();
    }

    async function continueCreateGame() {
      setAllowUpgradeModal(false);
      setLoading(true);
     
      const newGame = await UseCloudFunction(
        'duplicateOwnerGame',
        {
          'gameId': gameElement.gameData.gameId,
          'appId': userProfile.appId,
          'userProfile': userProfile,
          'fromTemplate': true
        }
      )
      setLoading(false);
      console.log(newGame);
      if (newGame.error) {
        setAlertMessage(`Something went wrong while creating the game. Please try again later. (Error: ${newGame.error})`);
        return;
      }
      setAlertMessage(`Your new game has been created successfully! You can now start editing it.`);
      approveRef.current = () => {
        navigate(`/manage/${newGame.gameData.path}`);
      }
    }
  }

  return (
    <div className={`create-from-template ${screenSize}`}>
      <div className='create-from-template-content g-card'>
        <BackButton cancel={() => navigate(-1)} />
        <div className="g-space-1"></div>
        <div className='card-title'>
          <span>Start With a Template</span>
        </div>
        <hr />
        <Routes>
          <Route path='' element={
            <div className='create-from-template-content__sub'>
              <p>Choose a template below to start creating your game.</p>
              {/* Template list will go here */}
              <div className='template-list'>
                {
                  (
                    gamesToDisplay && 
                    Object.keys(gamesToDisplay).length > 0
                  )
                    ? Object.keys(gamesToDisplay)
                    .sort((a,b) => a.access > b.access ? 1 : -1)
                    .map((gameId, index) => {
                      const game = gamesToDisplay[gameId];
                      const restricted = ((game.openDate && game.openDate > new Date().getTime()) || 
                        (game.closeDate && game.closeDate < new Date().getTime()));
                      return (
                        <div key={index} className='template-item g-list-item'>
                          <div className="item-grid">
                            <div>
                              <ImageContainer src={game.gameData.icon} alt={game.gameData.gameName} />
                            </div>
                            <div className='template-info'>
                              <h2>{game.gameData.gameName}</h2>
                              <div className="g-space-0-5"></div>
                              <div className='meta'>
                                {
                                  (screenSize === 'mobile')
                                    ?
                                    <Link to={game.gameData.path}>
                                      Learn More
                                    </Link>
                                    :
                                    <Link to={game.gameData.path}>
                                      <button className='g-button small-btn'>
                                        Learn More
                                      </button>
                                    </Link>
                                }
                              </div>
                              {/* <div className='meta'><b>Description:</b></div>
                                                        <div dangerouslySetInnerHTML={{__html: game.data.desc}}></div> */}
                            </div>
                          </div>
                          <div className='buttons'>
                            <button
                              className={`g-button med-btn`}
                              onClick={() => 
                                restricted
                                ? setShowUpgradeModal('You must have a certain level of membership to access this template. Please upgrade to view this template.')
                                : createGame(gameId)}>
                              Use This Template
                            </button>
                          </div>
                        </div>
                      )
                    })
                    : <p className='meta'><i>No templates available.</i></p>
                }
              </div>
            </div>
          }></Route>
          <Route path=':templatePath' element={
            <TemplateGamePreview />
          }></Route>
        </Routes>

      </div>
      {
        (screenSize === 'mobile') &&
        <div className='g-space-1'></div>
      }
      <ModalAlert
        show={alertMessage}
        cancel={() => setAlertMessage(null)}
        message={alertMessage}
        onApprove={approveRef.current} />
      <ModalConfirm
        show={confirmMessage}
        cancel={() => setConfirmMessage(null)}
        message={confirmMessage}
        onApprove={approveRef.current} />
      <UpgradeRequiredModal
        show={showUpgradeModal}
        cancel={() => setShowUpgradeModal(false)}
        message={showUpgradeModal}
        closeButton={allowUpgradeClose}
        newTab={false} />
      <FullPageLoader
        show={loading} />

      <div className="g-space-2"></div>
    </div>
  )
}

export default CreateFromTemplate